import requiredFieldsRaw from './requiredFields.json';
import { getOrgConfig } from '../utils/organizationConfigUtil';

// Brand placeholders resolved once, at module load
const TOKENS = {
    '{{CLIENT_APPROVAL_EMAIL}}': getOrgConfig()?.emails?.clientApproval,
};

const resolveTokens = (value) => {
    if (typeof value === 'string') {
        return Object.entries(TOKENS).reduce(
            (resolved, [token, replacement]) => resolved.split(token).join(replacement),
            value
        );
    }

    if (Array.isArray(value)) {
        return value.map(resolveTokens);
    }

    if (value && typeof value === 'object') {
        return Object.fromEntries(
            Object.entries(value).map(([key, val]) => [key, resolveTokens(val)])
        );
    }

    return value;
};

const requiredFieldConfig = resolveTokens(requiredFieldsRaw);

export default requiredFieldConfig;
